export default __webpack_public_path__ + "static/media/Image From ET__UI_1.676c01b7.png";